module.exports = __webpack_public_path__ + "static/notification4-48095599e1bfb27f713d46d5bfce33f8.png";